import { useEffect, useState } from "react";

// Utils
import { SignalRReceiveUpdatesRequoteClaimResponse } from "@/main/models/common/signalRReceiveUpdatesResponse";
import { RequoteClaimProgressEnum } from "@/main/services/enum/RequoteClaimProgressEnum";
import { SendUpdatesSignalRTypeEnum } from "@/main/services/enum/SendUpdatesSignalRTypeEnum";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { signalRClearReceiveUpdatesByKey } from "@/main/store/signalR";
import { Step, StepLabel, StepLabelProps, Stepper } from "@mui/material";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { SpinnerLoading } from "../styles";
import * as S from "./styles";
interface HubItemRequoteClaimProps {
	data: SignalRReceiveUpdatesRequoteClaimResponse[];
	customProps?: {
		onFinishedRequote: () => void;
		onErrorRequote: () => void;
	};
}

const HubItemRequoteClaim = ({ data, customProps }: HubItemRequoteClaimProps) => {
	const dispatch = useDispatch();

	const formatteedData = isNullUndefined(data) ? [] : data;
	const [activeStep, setActiveStep] = useState(0);

	const hasErrorRequote = formatteedData.some((item) => item.progressStatus === RequoteClaimProgressEnum.Error);
	const hasFinishedRequote = formatteedData.some((item) => item.progressStatus === RequoteClaimProgressEnum.Finished);
	const stepsWithLabel = [
		{
			key: RequoteClaimProgressEnum.CancelingItems,
			label: getTranslateByKey("requoteProcurement.cancelingItems"),
		},
		{
			key: RequoteClaimProgressEnum.CreatingNewQuote,
			label: getTranslateByKey("requoteProcurement.creatingNewQuote"),
		},
		{
			key: RequoteClaimProgressEnum.SelectingSuppliers,
			label: getTranslateByKey("requoteProcurement.selectingSuppliers"),
		},
		{
			key: RequoteClaimProgressEnum.Finished,
			label: getTranslateByKey("requoteProcurement.finished"),
		},
	];

	function getCustomIconProp(currentIndex: number): StepLabelProps {
		if (!hasFinishedRequote && !hasErrorRequote && currentIndex === activeStep)
			return { icon: <SpinnerLoading customSize="20px" /> };
		return {};
	}

	useEffect(() => {
		const lastItemRequoteSignalR = formatteedData[formatteedData.length - 1];
		if (isNullUndefined(lastItemRequoteSignalR)) {
			setActiveStep(0);
			return;
		}
		if (hasErrorRequote) {
			const findedStepError = formatteedData.find((item) => item.progressStatus === RequoteClaimProgressEnum.Error);
			const messageError = isNullUndefined(findedStepError)
				? getTranslateByKey("information.somethingWrong", true)
				: findedStepError.message;
			toast.error(messageError, { autoClose: 10000 });
			if (!isNullUndefined(customProps?.onErrorRequote)) customProps.onErrorRequote();
			return;
		}
		const findedIndexCurrent = stepsWithLabel.findIndex((item) => item.key === lastItemRequoteSignalR.progressStatus);

		setActiveStep(findedIndexCurrent === -1 ? 0 : findedIndexCurrent + 1);
		if (hasFinishedRequote) {
			if (!isNullUndefined(customProps?.onFinishedRequote)) customProps.onFinishedRequote();
			dispatch(signalRClearReceiveUpdatesByKey(SendUpdatesSignalRTypeEnum.RequoteClaim));
			return;
		}
	}, [JSON.stringify(formatteedData)]);

	return (
		<S.Container>
			<Stepper activeStep={activeStep} orientation="vertical">
				{stepsWithLabel.map((item, index) => (
					<Step key={`stepper-${index}`}>
						<StepLabel error={hasErrorRequote && index === activeStep} {...getCustomIconProp(index)}>
							{item.label}
						</StepLabel>
					</Step>
				))}
			</Stepper>
		</S.Container>
	);
};

export default HubItemRequoteClaim;
